import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Fade from 'react-reveal/Fade';
import '../custom-build/steps.scss';

import buttonarrow from '../../assets/images/button-arrow.svg';
import person from '../../assets/images/person.svg';
import orderEntryimg from '../../assets/images/order-entry.svg';

class OrderEntryView extends Component {
    render() {
        return (
            <div className="home-content steps-content">
                <div className="homeleftcontent steps-left">
                    <Fade right>
                        <h4>Quickly create quotes and orders in a few simple steps. Get started with pre-defined templates for standard, repeat, sample and virtual orders.</h4>
                    </Fade>
                    <Fade right><p className="steps-text">Detailed customer and item masters autofill information to make order entry incredibly smooth and fast.</p></Fade>
                    <Fade right>
                        <div className="button-section">
                            <Link to="/home" className="theme-btn backarrow-btn"><img alt="" src={buttonarrow} /></Link>
                            <Link to="/ArtworkProofing" className="theme-btn">Artwork proofing <img alt="" src={buttonarrow} /></Link>
                        </div>
                    </Fade>
                    <div className="bottom-person">
                            <Fade right>
                            <img alt="Customer Portal" src={person} />
                            <div className="person-right">
                                <h3>Search and view orders</h3>
                                <small>Customer Portal</small>
                            </div>
                        </Fade>
                    </div>
                </div>
                <div className="homerightcontent">
                    <Fade right>
                        <img alt="Custom Built" src={orderEntryimg} />
                    </Fade>
                </div>
            </div>
        )
    }
}

export default OrderEntryView
